import { render, staticRenderFns } from "./PackMenuList.vue?vue&type=template&id=04510bb6&scoped=true&"
import script from "./PackMenuList.vue?vue&type=script&lang=js&"
export * from "./PackMenuList.vue?vue&type=script&lang=js&"
import style0 from "./PackMenuList.vue?vue&type=style&index=0&id=04510bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04510bb6",
  null
  
)

export default component.exports